import useMediaQuery from 'hooks/useMediaQuery';
import { data } from '../mockData';
import HeaderNavigationItem from './HeaderNavigationItem';
import MobileSocialBlock from '../MobileSocialBlock';

const HeaderNavigation = () => {
    const isTablet = useMediaQuery('max-width: 1023px');

    return (
        <div className="header-nav">
            {data.map(category => (
                <HeaderNavigationItem key={category.name} category={category} />
            ))}
            {isTablet && <MobileSocialBlock />}
        </div>
    );
};
export default HeaderNavigation;
